import { useGenUiConfig } from '../../shared/ui/config.js';

/** Uma perna da linha do tempo do voo (GET /flight/legs). Display-only, fail-soft.
 *  Movida de `business/booking_approval/port.ts` para o domínio de flight offers —
 *  o drawer "Detalhe do voo" NÃO é checkout e sobrevive à remoção do booking_approval. */
export interface FlightLeg {
  origin: { iata: string; name?: string; at?: string };
  destination: { iata: string; name?: string; at?: string };
  durationSeconds?: number;
  /** Parada após a perna (`waitSecondsUntilNextFlight`) — ausente na última. */
  layoverSeconds?: number;
  carrier?: { code?: string; name?: string };
  operatedBy?: { code?: string; name?: string };
  /** Operada por outra cia ("troca de aeronave"). */
  aircraftChange?: boolean;
  flightNumber?: string;
  isConnection?: boolean;
  cabin?: string;
  /** Código IATA da cia desta perna — compõe "continua no voo AD 2778". */
  carrierCode?: string;
  /** Direção num round-trip — divide o drawer em seções Ida/Volta. */
  direction?: 'outbound' | 'return';
  /** Enriquecimento Cirium via BFF — ausentes quando a malha não cobre o voo. */
  aircraftName?: string;
  departureTerminal?: string;
  arrivalTerminal?: string;
  /** Pontualidade histórica (0–100 + amostra) — ausente sem histórico robusto. */
  onTimePercent?: number;
  onTimeObservations?: number;
  /** Voos de marketing que revendem esta perna ("AF 3647", ...). */
  soldAs?: string[];
}

/** Port de leitura do drawer de detalhe da OFERTA (não-checkout). Injetado via
 *  `GenUiConfig.ports.flightOffers`. Ausente ⇒ o drawer degrada fail-soft. */
export interface FlightOffersPort {
  getLegs: (offerId: string) => Promise<FlightLeg[]>;
}

/** Lê só o port de flight offers do Context. `null` quando o host não o injeta. */
export function useFlightOffersPort(): FlightOffersPort | null {
  return useGenUiConfig().ports?.flightOffers ?? null;
}
